import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core'
import { DocumentsStore, ItemWithID } from '../../stores/document.store'
import { Dictionary, SearchOption, SearchOptionGroup } from '../filtering-search-component-base/filtering-search-types'
import { Store } from '@ngrx/store'
import { selectUser } from 'src/app/state/user.reducer'
import { Observable } from 'rxjs'
import { User } from 'src/app/state/user.model'
import { BackEndService } from 'src/app/services/backend.service'
import { IconNamesEnum } from 'ngx-bootstrap-icons'
import { ActivatedRoute } from '@angular/router'
import { ToastService } from 'src/app/services/toast.service'

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})

export class DocumentsViewerBase<Document extends ItemWithID> implements OnInit {

  public store = inject<Store<any>>(Store)
  protected backendService = inject(BackEndService)
  protected route = inject(ActivatedRoute)

  @Input() public requiredFilters: Dictionary<any> = {}
  @Input() public searchclasses = ''
  @Input() public showCaseInfo = true
  @Input() public contentSet: string | undefined

  @Input('embedded') set setType(embedded: boolean) {
    this.embedded = embedded
    if (embedded) {
      this.saveSearchesText = 'Follow'
    } else {
      this.saveSearchesText = 'Save Filters'
    }
  }

  @Input() public documentSearchOptionGroups: SearchOptionGroup[] = []
  @Input() public initialSearch = {
    parameters: {

    },
    order: {
      column: 'date',
      direction: 'desc'
    }
  }

  public embedded = false
  public saveSearchesText = 'Save Filters'

  public documents$
  public loading$
  public error$
  public listing$
  public search$

  public user$: Observable<User | null>

  public iconNames = IconNamesEnum

  public searchResultsColumnDefinition: Dictionary<SearchOption> = {}

  public toastService = inject(ToastService)

  constructor(protected readonly documentsStore: DocumentsStore<Document>) {
    this.documents$ = this.documentsStore.documents$
    this.loading$ = this.documentsStore.loading$
    this.error$ = this.documentsStore.error$
    this.listing$ = this.documentsStore.listing$
    this.search$ = this.documentsStore.search$

    this.user$ = this.store.select(selectUser)
    this.contentSet = this.contentSet ?? this.route.snapshot.data['contentSet']
    this.documentSearchOptionGroups = structuredClone(this.route.snapshot.data['searchOptionGroups'])
  }

  ngOnInit(): void {
    this.documentSearchOptionGroups.forEach(optionGroup => {
      optionGroup.options.forEach(option => {
        this.searchResultsColumnDefinition[option.id] = option
      })
    })
  }

  loadMoreDocuments() {
    this.documentsStore.getDocuments()
  }

  toggleOrder(search: any, column: string) {
    let direction = 'asc'
    if (search.order.column === column) {
      direction = search.order!.direction === 'asc' ? 'desc' : 'asc'
    }

    this.documentsStore.updateSearch({
      ...search,
      order: {
        ...search.order,
        column,
        direction
      }
    })
  }
}